import {
  useEffect
} from "react";

import {
  useAuth
} from "../context/AuthContext";

import {
  useAuthModal
} from "../context/AuthModalContext";

function ProtectedRoute({ children }) {

  const { user } =
    useAuth();

  const {
    openAuthModal
  } = useAuthModal();

  /* ===============================
     OPEN AUTH MODAL
  =============================== */

  useEffect(() => {

    if (!user) {

      openAuthModal("/cart");

    }

  }, [user, openAuthModal]);

  /* ===============================
     BLOCK ACCESS
  =============================== */

  if (!user) {

    return null;

  }

  /* ===============================
     ALLOW ACCESS
  =============================== */

  return children;

}

export default ProtectedRoute;